/* unplugin-vue-components disabled */
import {FiltersCalendar, FiltersDropdown, Filters} from './filters-elements'

export default {
  components: {FiltersCalendar, FiltersDropdown, Filters},
  mixins: [ModelValue(Array)],
  props: {
    width: {
      type: String,
      default: '28.5rem'
    },
    title: {
      type: String,
      default: 'Dates'
    },
    filterIndicator: {
      type: Boolean,
      default: true
    },
    minDate: {
      type: Date,
      default: undefined
    },
  }
}
